import { AnimatePresence, motion } from "motion/react";
import { bool, oneOfType, string } from "prop-types";

import styled from "styled-components";

import FnrTypography from "UI/FnrTypography";
import { colorsByFunction } from "UI/colors";

const HEIGHT_TRANSITION = { duration: 0.2 };
const HEIGHT_INITIAL = { height: 0 };
const HEIGHT_ANIMATE = { height: "auto" };
const OPACITY_TRANSITION = { duration: 0.15 };
const OPACITY_INITIAL = { opacity: 0 };
const OPACITY_ANIMATE = { opacity: 1 };
const OVERFLOW_HIDDEN_STYLE = { overflow: "hidden" };

export default function AttachedError({ error }) {
  return (
    <AnimatePresence>
      {error && (
        <motion.div
          initial={HEIGHT_INITIAL}
          animate={HEIGHT_ANIMATE}
          exit={HEIGHT_INITIAL}
          transition={HEIGHT_TRANSITION}
          style={OVERFLOW_HIDDEN_STYLE}
        >
          <ErrorBox>
            <FnrTypography
              as={motion.span}
              fontSize="xs"
              bold
              color="textWarning"
              initial={OPACITY_INITIAL}
              animate={OPACITY_ANIMATE}
              exit={OPACITY_INITIAL}
              transition={OPACITY_TRANSITION}
            >
              {error}
            </FnrTypography>
          </ErrorBox>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

AttachedError.propTypes = {
  error: oneOfType([string, bool]),
};

const ErrorBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: ${colorsByFunction.warningBg};
  border: 1px solid ${colorsByFunction.warningBorder};
  border-top: none;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  text-align: center;
  min-width: 0;
`;
